import React, { useState, useEffect } from 'react';


export function ContractorAttendanceDailogAttendanceDay({ obj }) {
    const [recruitment, setRecruitment] = useState(null)
    const [dates, setDates] = useState("")
    const [caseOnBoardDate, setCaseOnBoardDate] = useState("")
    const [caseResignDate, setCaseResignDate] = useState("N/A")
    const [AttendanceDay, setAttendanceDay] = useState("")


    useEffect(() => {
        if (obj !== undefined && obj !== recruitment) {
            setRecruitment(obj)
            setDates(obj.dates)
            setCaseOnBoardDate(obj.caseInfo.caseOnBoardDate)
            if(obj.caseInfo.caseResignDate !== ""){
                setCaseResignDate(obj.caseInfo.caseResignDate)
            }
            setAttendanceDay(obj.AttendanceDay)
        }
    }, [obj])
    return (
        <table className="table table-striped table-bordered table-hover  dataTable">
            <thead>
                <tr role="row">
                    <th className="text-center sorting col-sm-6">項目名稱</th>
                    <th className="text-right sorting col-sm-6">數值</th>
                </tr>
                <tr role="row">
                    <td className="text-center">起迄期間</td>
                    <td className="text-right">{dates}
                    </td>
                </tr>
                <tr role="row">
                    <td className="text-center">到職日</td>
                    <td className="text-right">{caseOnBoardDate}
                    </td>
                </tr>
                <tr role="row">
                    <td className="text-center">離職日</td>
                    <td className="text-right">{caseResignDate}
                    </td>
                </tr>
                <tr role="row">
                    <td className="text-center">出勤天數</td>
                    <td className="text-right">{AttendanceDay}
                    </td>
                </tr>
            </thead>
        </table>
    )
}
